import { render, staticRenderFns } from "./ListPeoplePage.vue?vue&type=template&id=d461e3a8"
import script from "./ListPeoplePage.vue?vue&type=script&lang=js"
export * from "./ListPeoplePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports